export const songs = [
  {
    id: 1,
    title: "Midnight Groove",
    artist: "Neon Nights",
    album: "Synthwave Dreams",
    duration: "3:45",
    cover: "https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=300&h=300&fit=crop",
    audioUrl: "/audio/sample-tracks/midnight-groove.mp3",
    genre: "Synthwave"
  },
  {
    id: 2,
    title: "Electric Pulse",
    artist: "Retro Wave",
    album: "Digital Nostalgia",
    duration: "4:12",
    cover: "https://images.unsplash.com/photo-1571330735066-03aaa9429d89?w=300&h=300&fit=crop",
    audioUrl: "/audio/sample-tracks/electric-pulse.mp3",
    genre: "Electronic"
  },
  {
    id: 3,
    title: "Analog Dreams",
    artist: "Vintage Vibes",
    album: "Tape Deck",
    duration: "3:28",
    cover: "https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=300&h=300&fit=crop",
    audioUrl: "/audio/sample-tracks/analog-dreams.mp3",
    genre: "Chillwave"
  },
  {
    id: 4,
    title: "Neon Lights",
    artist: "Synthwave Master",
    album: "80s Revival",
    duration: "5:02",
    cover: "https://images.unsplash.com/photo-1571330735066-03aaa9429d89?w=300&h=300&fit=crop",
    audioUrl: "/audio/sample-tracks/neon-lights.mp3",
    genre: "Synthwave"
  },
  {
    id: 5,
    title: "Time Machine",
    artist: "Retro Future",
    album: "Back to the Future",
    duration: "4:33",
    cover: "https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=300&h=300&fit=crop",
    audioUrl: "/audio/sample-tracks/time-machine.mp3",
    genre: "Retrowave"
  }
];
